import styled from 'styled-components';

export const ApplicantsSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .table {
    width: 90vw;
    border-collapse: collapse; /* Collapse borders */
    border-radius: 10px;
    
    color: white; /* Text color */
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); /* Shadow for 3D effect */

    th, td {
      padding: 12px 15px; /* Padding inside cells */
      text-align: left; /* Align text to the left */
      border-bottom: 1px solid #ddd; /* Border between rows */
    }

    th {
        background-color: #1a4eb0;
      color: #fff; /* White text for header */
    }

    tr:nth-child(even) {
    }

    tr:hover {
    /* Hover effect for rows */
      color: #000;
      cursor: pointer;
    }
  }
`;

